module.exports = __webpack_public_path__ + "static/media/broken-chain.8dc18263.svg";